<template>
  <div class="riepilogo-ferie col-xs-24">
    <keep-alive>
      <riepilogo-ferie-it v-if="country === '1'"></riepilogo-ferie-it>
      <riepilogo-ferie-fr v-if="country === '2'"></riepilogo-ferie-fr>
      <riepilogo-ferie-es v-if="country === '3'"></riepilogo-ferie-es>
      <riepilogo-ferie-be v-if="country === '4'"></riepilogo-ferie-be>
      <riepilogo-ferie-de v-if="country === '5'"></riepilogo-ferie-de>
    </keep-alive>

  </div>
</template>

<script>
  import RiepilogoFerieIt from './RiepilogoFerieMobile1.vue'
  import RiepilogoFerieFr from './RiepilogoFerieMobile2.vue'
  import RiepilogoFerieEs from './RiepilogoFerieMobile3.vue'
  import RiepilogoFerieBe from './RiepilogoFerieMobile4.vue'
  import RiepilogoFerieDe from './RiepilogoFerieMobile5.vue'

  export default {
    name: 'RiepilogoFerie',
    components: {RiepilogoFerieIt, RiepilogoFerieFr, RiepilogoFerieEs, RiepilogoFerieBe, RiepilogoFerieDe},
    props: ['tableHeight'],
    data () {
      return {
        country: "",
      }
    },
    activated: function () {
      this.country = this.$store.state.country
    },
    methods: {
    }
  }
</script>


<style lang="less">
  @import "../../assets/less/general.less";

</style>



// WEBPACK FOOTER //
// src/components/FerieMobile/RiepilogoFerieMobile.vue